import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PatchTypeBreakdown } from '../../../../models/patch-management.models';

@Component({
  selector: 'app-patches-by-type-bars',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './patches-by-type-bars.component.html',
  styleUrls: ['./patches-by-type-bars.component.scss'],
})
export class PatchesByTypeBarsComponent {
  @Input({ required: true }) patchTypes: PatchTypeBreakdown[] = [];
  @Input() activePatchType: string | null = null;
  @Output() patchTypeSelect = new EventEmitter<string>();

  /** Raw `100 - pct` re-introduces float noise (e.g. 8.899999999999999) — round it here instead */
  missPct(pct: number): number {
    return Math.round((100 - pct) * 10) / 10;
  }

  tooltip(t: PatchTypeBreakdown): string {
    return `Installed ${t.pct}% · Missing ${this.missPct(t.pct)}%`;
  }
}
